import { combineReducers } from '@reduxjs/toolkit';
import { listSlice } from './listSlice';
import { editSlice } from './editSlice';
import { registrationSlice } from './registrationSlice';

export const apiKeyTemplateReducer = combineReducers({
  list: listSlice.reducer,
  registration: registrationSlice.reducer,
  edit: editSlice.reducer,
});
